module.exports = __webpack_public_path__ + "img/main-block-product-showcase.54f5944c.svg";